// src/pages/FormFirmaPage.tsx
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Paper, Typography, TextField, Button, Alert, CircularProgress } from "@mui/material";
import api from "../api/axios";
import { useTranslation } from "react-i18next";

export default function FormFirmaPage() {
  const { t, i18n } = useTranslation<"translation">();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [loading, setLoading] = useState(true);
  const [info, setInfo] = useState<any>(null);
  const [motivo, setMotivo] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/form-firma", { params: { token } });
        setInfo(data);
      } catch (e: any) {
        setError(e?.response?.data?.message ?? "Invalid link");
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const submit = async () => {
    setError(null);
    try {
      await api.post("/form-firma", { motivo }, { params: { token } });
      setDone(true);
    } catch (e: any) {
      setError(e?.response?.data?.message ?? "Error");
    }
  };

  if (loading) return <CircularProgress sx={{ m: 4 }} />;

  if (error)
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        {error}
      </Alert>
    );

  if (done || info?.estado === "SIGNED") {
    return (
      <Alert severity="success" sx={{ m: 3 }}>
        {t("formFirma.done", {
          defaultValue: "¡Gracias! La clase ha quedado registrada como firmada por formulario.",
        })}
      </Alert>
    );
  }

  return (
    <Box sx={{ p: 3, display: "flex", justifyContent: "center" }}>
      <Paper sx={{ p: 3, maxWidth: 560, width: "100%" }}>
        <Typography variant="h6" gutterBottom>
          {t("formFirma.title", { defaultValue: "Motivo de no firma" })}
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("formFirma.subtitle", {
            defaultValue: "Profesor: {{p}} · Alumno: {{a}}",
            p: info?.profesor ?? "—",
            a: info?.alumno ?? "—",
          })}
        </Typography>
        <TextField
          multiline
          rows={4}
          fullWidth
          inputProps={{ maxLength: 500 }}
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          label={t("formFirma.reason", {
            defaultValue: "Escribe el motivo (máx. 500 caract.)",
          })}
        />
        <Box sx={{ mt: 2, textAlign: "right" }}>
          <Button variant="contained" onClick={submit} disabled={!motivo.trim()}>
            {t("formFirma.send", { defaultValue: "Enviar" })}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
